import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from "chart.js";
import { Pie } from "react-chartjs-2";
import { useMemo } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { useAppSelector } from "../../../../../hooks/store-hooks";
import { theme } from "../../../../../styles";

ChartJS.register(ArcElement, ChartTooltip, Legend);

export const RelatorioProjeto = () => {
  const { relatorioProjeto } = useAppSelector((state) => state.projetos);

  const velesGeo : Number = (Number(relatorioProjeto?.dados.exportados)  + Number(relatorioProjeto?.dados.disponiveis))|| 0
            

  const exportedData = useMemo(() => {
    return {
      labels: [
        "Veles-Geo",
        "Extraídos", 
        "Disponíveis"
      ],
      datasets: [
        {
          label: "Registros",
          data: [
            velesGeo || 0,
            relatorioProjeto?.dados.exportados || 0,
            relatorioProjeto?.dados.disponiveis || 0,
          ],
          backgroundColor: [
            "rgba(225,217,230,1)",  // Veles-Geo
            "rgba(254,223,229,1)", // Extraídos
            "rgba(218,235,251,1)", // Disponíveis
          ],
          borderColor: [
            "rgba(137,119,143,1)",
            "rgba(255, 99, 132, 1)",
            "rgba(148, 191, 226, 1)",
          ],
          borderWidth: 1,
        },
      ],
    };
  }, [
    velesGeo,
    relatorioProjeto?.dados.exportados,
    relatorioProjeto?.dados.disponiveis,
  ]);

  return (
    <Box p={3} width="100%">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            align="center"
            fontWeight="bold"
            variant="h5"
            color="primary"
          >
            Quantitativo
          </Typography>
          <Box p={2}>
            <Grid container justifyContent="center">
              <Grid item>
                <Pie data={exportedData} />
              </Grid>
            </Grid>
          </Box>

          {/* Valores numéricos */}
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <Typography align="center" fontWeight="bold">
                <span style={{ color: "rgba(137,119,143,1)" }}>
                  Veles-Geo:
                </span>{" "}
                {velesGeo.toLocaleString("pt-BR") || 0}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography align="center" fontWeight="bold">
                <span style={{ color: "rgba(255, 99, 132, 1)" }}>
                  Extraídos:
                </span>{" "}
                {relatorioProjeto?.dados.exportados?.toLocaleString("pt-BR") || 0}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Divider variant="middle" color={theme.palette.primary.main} />
        </Grid>

        <Grid item xs={12}>
          <Typography align="center" fontWeight="bold">
            <span style={{ color: "rgba(54, 162, 235, 1)" }}>
              Disponíveis:
            </span>{" "}
            {relatorioProjeto?.dados.disponiveis?.toLocaleString("pt-BR") || 0}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};